// extracted by mini-css-extract-plugin
module.exports = {"datePickerRoot":"styles_datePickerRoot__3uEM0"};